if (!window.dpEditorialShareReady) {
  window.dpEditorialShareReady = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.dp-editorial-share__copy');
    if (!button) return;

    const url = button.dataset.copyUrl;
    if (!url) return;

    const showCopied = () => {
      button.classList.add('is-copied');
      window.setTimeout(() => button.classList.remove('is-copied'), 1400);
    };

    try {
      await navigator.clipboard.writeText(url);
    } catch (error) {
      const textarea = document.createElement('textarea');
      textarea.value = url;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      textarea.remove();
    }

    showCopied();
  });
}
